<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-15 11:15:13
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-17 19:39:17
-->
<template>
  <div class="subjective-question">
    <el-form
      ref="subjectiveForm"
      :model="questionInfo"
      :rules="rules"
      label-width="100px"
      class="subjectiveForm"
    >
      <el-form-item label="题干:" prop="questionName">
        <tinymce
          ref="editor"
          v-model="questionInfo.questionName"
          height="240"
          width="783"
        ></tinymce>
      </el-form-item>
      <el-form-item label="标准答案:" prop="questionAnswer">
        <tinymce
          v-for="(item, index) in questionInfo.optionList"
          :key="index"
          ref="editor"
          v-model="item.optionName"
          height="480"
          width="783"
        ></tinymce>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button :loading="saveLoading" type="primary" @click="save">保存</el-button>
      <el-button @click="remove">删除</el-button>
    </div>
  </div>
</template>
<script>
import Tinymce from '@/components/Tinymce'
export default {
  name: 'SubjectiveQuestion',
  components: { Tinymce },
  props: {
    questionInfo: {
      type: Object,
      default: () => ({}),
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tagList: ['a'],
      rules: {
        questionName: [{ required: true, message: '请输入题干', trigger: 'blur' }],
        questionAnswer: [{ required: true, message: '请输入标准答案', trigger: 'blur' }],
      },
    }
  },
  methods: {
    save() {
      const { questionName, questionType, score, optionList } = this.questionInfo
      let optionObj = {}
      let rightKeyArr = []
      optionList.map((item, index) => {
        this.$set(optionObj, this.tagList[index], item.optionName)
        rightKeyArr.push(index + 1)
      })
      let params = {
        questionName,
        questionType,
        score,
        ...optionObj,
        rightKey: rightKeyArr.join(','),
      }
      this.$emit('edit', params)
    },
    remove() {
      this.$emit('remove')
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/.el-form {
  .tox-tinymce {
    width: 820px;
  }
  .el-radio-group {
    padding-top: 5px;
  }
  .el-radio {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .el-radio__label {
    box-sizing: border-box;
    display: block;
    width: 100px;
    height: 30px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #d8dee6;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
    padding: 0;
  }
}
</style>
